export const FLOW_DISPLAY_NAME = {
  MF: 'Mutual Funds',
  BANK: 'Bank -', //Independent w-flow.
  E_SIGN: 'E_SIGN -', //Independent w-flow.
  MF_SHORT: 'Mutual Funds',
  MF_NRI: 'Mutual Funds - NRI',
  MF_NRI_RE_KYC: 'Mutual Funds - NRI, RE -',
  MF_MINOR: 'Mutual Funds - Minor',
  BROKING: 'Broking',
  BROKING_RE_KYC: 'Broking, RE -',
  BROKING_DDPI: 'Broking - DDPI',
  BROKING_FNO: 'Broking - F & O',
  FI: 'FI',
  PARTNER: 'Partner',
  PARTNER_BANK: 'Partner Bank',
  PARTNER_ARN: 'Partner ARN',
  PARTNER_GST: 'Partner GST',
  ALL_FI: 'Net Worth',
};

export const FLOW_ACC_NAME_MAPPING = {
  MF: 'Basic Account',
  BANK: 'Bank -', //Independent w-flow.
  E_SIGN: 'E_SIGN -', //Independent w-flow.
  MF_SHORT: 'Basic Account',
  MF_NRI: 'Basic Account - NRI',
  MF_NRI_RE_KYC: 'Basic Account - NRI, RE -',
  MF_MINOR: 'Mutual Fund Account',
  BROKING: 'All In One Account',
  BROKING_RE_KYC: 'All In One Account',
  BROKING_DDPI: 'All In One Account - DDPI',
  BROKING_FNO: 'All In One Account - F & O',
  FI: 'Net Worth',
  PARTNER: 'Partner',
  PARTNER_BANK: 'Partner Bank',
  PARTNER_ARN: 'Partner ARN',
  PARTNER_GST: 'Partner GST',
  ALL_FI: 'Net Worth Account',
};

export const KYC_FLOWS = {
  BROKING: 'BROKING',
  BROKING_RE_KYC: 'BROKING_RE_KYC',
  BROKING_FNO: 'BROKING_FNO',
  BROKING_DDPI: 'BROKING_DDPI',
  BROKING_ACC_CLOS: 'BROKING_ACC_CLOS',
  FI: 'FI',
  MF: 'MF',
  MF_SHORT: 'MF_SHORT',
  MF_NRI: 'MF_NRI',
  MF_NRI_RE_KYC: 'MF_NRI_RE_KYC',
  MF_MINOR: 'MF_MINOR',

  //NOTE:  Generic Flows
  BANK: 'BANK',
  SELFIE: 'SELFIE',
  E_SIGN: 'E_SIGN',

  //NOTE:  Partner Flows
  PARTNER: 'PARTNER',
  PARTNER_BANK: 'PARTNER_BANK',
  PARTNER_ARN: 'PARTNER_ARN',
  PARTNER_GST: 'PARTNER_GST',

  //NOTE:  Net-worth flow
  ALL_FI: 'ALL_FI',
};

export const PARTNER_FLOWS = [
  KYC_FLOWS.PARTNER,
  KYC_FLOWS.PARTNER_ARN,
  KYC_FLOWS.PARTNER_GST,
  KYC_FLOWS.PARTNER_BANK,
];
export const CLIENT_FLOWS = [
  KYC_FLOWS.BROKING,
  KYC_FLOWS.BROKING_RE_KYC,
  KYC_FLOWS.BROKING_FNO,
  KYC_FLOWS.BROKING_DDPI,
  KYC_FLOWS.BROKING_ACC_CLOS,
  KYC_FLOWS.FI,
  KYC_FLOWS.MF,
  KYC_FLOWS.MF_SHORT,
  KYC_FLOWS.MF_NRI,
  KYC_FLOWS.MF_NRI_RE_KYC,
  //NOTE:  Generic Flows
  KYC_FLOWS.BANK,
  KYC_FLOWS.SELFIE,
  KYC_FLOWS.E_SIGN,
  KYC_FLOWS.ALL_FI,
];

export const KYC_PROGRESS_PERCENTAGE = {
  [KYC_FLOWS.BROKING]: 50,
  [KYC_FLOWS.BROKING_RE_KYC]: 100,
  [KYC_FLOWS.BROKING_FNO]: 100,
  [KYC_FLOWS.BROKING_DDPI]: 100,
  [KYC_FLOWS.BROKING_ACC_CLOS]: 60,
  [KYC_FLOWS.FI]: 100,
  [KYC_FLOWS.MF]: 50,
  [KYC_FLOWS.MF_SHORT]: 80,
  [KYC_FLOWS.MF_NRI]: 50,
  [KYC_FLOWS.MF_NRI_RE_KYC]: 100,
  [KYC_FLOWS.MF_MINOR]: 80,

  [KYC_FLOWS.BANK]: 80,
  [KYC_FLOWS.SELFIE]: 50,
  [KYC_FLOWS.E_SIGN]: 50,

  [KYC_FLOWS.PARTNER]: 20,
  [KYC_FLOWS.PARTNER_BANK]: 20,
  [KYC_FLOWS.PARTNER_ARN]: 20,
  [KYC_FLOWS.PARTNER_GST]: 20,

  [KYC_FLOWS.ALL_FI]: 100,
};

export const KYC_PROGRESS_PERCENTAGE_PRE_KYC = {
  [KYC_FLOWS.BROKING]: 45,
  [KYC_FLOWS.BROKING_RE_KYC]: 0,
  [KYC_FLOWS.BROKING_FNO]: 0,
  [KYC_FLOWS.BROKING_DDPI]: 0,
  [KYC_FLOWS.BROKING_ACC_CLOS]: 40,
  [KYC_FLOWS.FI]: 0,
  [KYC_FLOWS.MF]: 45,
  [KYC_FLOWS.MF_SHORT]: 20,
  [KYC_FLOWS.MF_NRI]: 45,
  [KYC_FLOWS.MF_NRI_RE_KYC]: 0,
  [KYC_FLOWS.MF_MINOR]: 18,

  [KYC_FLOWS.BANK]: 20,
  [KYC_FLOWS.SELFIE]: 50,
  [KYC_FLOWS.E_SIGN]: 50,

  [KYC_FLOWS.PARTNER]: 40,
  [KYC_FLOWS.PARTNER_BANK]: 40,
  [KYC_FLOWS.PARTNER_ARN]: 40,
  [KYC_FLOWS.PARTNER_GST]: 40,

  [KYC_FLOWS.ALL_FI]: 0,
};
